import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getIsBrandFirstData } from '../brand/brandSelectors';

import CashstarLogo from './CashstarLogo';
import FirstData from './FirstData';
import { getFooterLogosLinks } from '../app/bootstrap';


export const FooterLogos = ({
    isFirstData
}) => {
    const {
        cashstarWebsiteUrl,
        firstDataWebsiteUrl
    } = getFooterLogosLinks();

    return (
        <div className="footer-logos">
            <CashstarLogo cashstarWebsiteUrl={cashstarWebsiteUrl} />
            {isFirstData && <FirstData firstDataWebsiteUrl={firstDataWebsiteUrl} />}
        </div>
    );
};

FooterLogos.defaultProps = {
    isFirstData: false
};

FooterLogos.propTypes = {
    isFirstData: PropTypes.bool
};

export const mapStateToProps = state => ({
    isFirstData: getIsBrandFirstData(state)
});

export default connect(mapStateToProps)(FooterLogos);
